<template>



  <v-container fluid >

       <v-dialog v-model="showDialog" width="400px">
        <v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="showDialog = false;">
              Fechar
            </v-btn>
          </v-card-actions>
          <v-card-title>
            <span class="headline">Atualizar senha</span>
          </v-card-title>

           <v-card-text>
              <br />
              <v-row class="ma-4">
              <v-col>
                    <v-form @submit.prevent="submit" ref="form" v-model="valid">
                <v-text-field         
                  v-model="password"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.min]"
                  :type="show1 ? 'text' : 'password'"
                  name="input-10-1"
                  label="Senha"
                  hint="Pelo menos 6 caracteres"
                  counter
                  @click:append="show1 = !show1"
                ></v-text-field>

                    </v-form>
              </v-col>
            </v-row>
           </v-card-text>

           <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn @click="updatePassword">Salvar</v-btn>
           </v-card-actions>
        </v-card>
       </v-dialog>
    <v-row class="mx-4">
      <div class="text-h3" :class="`blue-grey--text text--darken-2`" color="">
        Meus dados


      </div>

         <v-progress-circular
          v-show="!loaded"
          indeterminate
          color="primary"
        ></v-progress-circular>
      <v-spacer></v-spacer>

      <v-btn
        outlined
        text
        class="primary"
        dark
        :disabled="saving"
        @click="save"
      >
        <span v-show="!saving">Salvar</span>
        <v-progress-circular
          v-show="saving"
          indeterminate
          color="white"
        ></v-progress-circular>
      </v-btn>
    </v-row>

   

    <v-container style="max-width: 1800px" v-if="loaded">
      <v-card>
        <v-toolbar color="primary" dark>
          Dados do usuário
          <v-spacer></v-spacer>
        </v-toolbar>

        <!-- <v-container  style="background-color:red;max-width:90%;"  > -->
        <v-container style="max-width: 90%">
          <!-- <v-row style="background-color:green" > -->
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                label="Nome"
                hide-details="auto"
                v-model="user.name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Email padrão"
                hide-details="auto"
                disabled
                v-model="user.email"
              ></v-text-field>
            </v-col>
                 <v-col cols="12" md="4">
              <v-text-field
                label="Fone"
                hide-details="auto"
                v-model="user.phone"
                v-if = "loaded"
                  v-mask= "(user.phone.length<=13)?'(##)####-####':'(##)#####-####'"
              ></v-text-field>
            </v-col>

            <v-col>
                <v-btn class="primary" @click="showDialog= true;">Alterar senha</v-btn>
            </v-col>
          </v-row>
   
          <v-row>
          </v-row>
        </v-container>
      </v-card>
  </v-container>

  </v-container>
  <!-- </v-card> -->
</template>

<script>
import cityNames from "@/libraries/data/cityNames.js";
import defaultFields from "@/libraries/data/fields.js";

import VComponent from "../../../../components/base/VComponent.vue";

import DefaultSettingsCard from "@/views/dashboard/components/cards/DefaultSettingsCard";
import QuoteProfilesCard from "@/views/dashboard/components/cards/QuoteProfilesCard";
import hebelApi from "../../../../libraries/hebel/hebelApi"


export default {
  components: {
    DefaultSettingsCard,
    QuoteProfilesCard,
  },
  name: "Home",

  data() {
    return {
        user:{},
        password:"",
              show1: false,
              showDialog:false,
              valid:false,
        rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 6 || "Min 6 characters",
        emailMatch: () => `The email and password you entered don't match`,
      },
      loading: false,
      items: [],
      searchCity: null,
      select: null,
      enterprise: {},
      services: [],
      fields: [],
      saving: false,

      color: "#000000",
      mask: "XXXXXXX",
      menu: false,

      color2: "#000000",
      mask2: "XXXXXXX",
      menu2: false,
      loaded:false,
    };
  },
  computed: {
    modeAdmin: function () {
      return (process.env.NODE_ENV === "development" || window.eid =="EFZwxQvKjmt6Bn4ZlzCg");
    },
    
  },
  async mounted() {
    //alert(window.uid)
    //Load user informations
    //var enterprise = await this.$dao.getEnterprise(window.eid);
    var user = await hebelApi.users.get(window.uid);

    this.user = user;
    // alert(this.color)
    // this.select = this.enterprise.cityName;
    this.searchCity = this.enterprise.cityName;
    //this.cities = cityNames;

    this.loaded =true;
  },
  watch: {
    searchCity(val) {
      val && val !== this.select && this.querySelections(val);
    },
  },
  methods: {

      submit(){
          //alert("Submit")
      },
     async updatePassword(){
        if(this.valid ==true )
          var updated = await hebelApi.users.updatePassword(this.password);
          this.showDialog = false;
        return;
      },
    async test(){
      //alert("test")

     //var mods = await hebelApi.getAllModules(window.eid)

     var mods = await hebelApi.deals.otherMethod();
      alert(JSON.stringify(mods))
    },

    changeImage(){
    //  alert("update");
      this.$forceUpdate();
    },
    async save() {
      this.saving = true;
      //var ans = await this.$dao.saveEnterprise(this.enterprise);
        var ans = await hebelApi.users.patch(this.user);



      this.saving = false;
    },

    querySelections(v) {
      this.loading = true;
      // Simulated ajax query
      setTimeout(() => {
        this.items = cityNames.filter((e) => {
          return (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
        });
        this.loading = false;
      }, 500);
    },

    getColor(calories) {
      if (calories > 400) return "red";
      else if (calories > 200) return "orange";
      else return "green";
    },

    complete(index) {
      this.list[index] = !this.list[index];
    },
  },
};
</script>

<style scoped>
.labelValue {
  display: block;
  width: 120px;
  margin: auto;
  text-align: center;
}
.cardLabel {
  position: absolute;
  right: 10px;
  top: 20px;
  height: 60px;
  width: 240px;
  background-color: #4c6563;
  border-radius: 15px;
}
table {
  border: none !important;
}
</style>
